import { render } from "./Perizinan.vue?vue&type=template&id=3f303ae8"
import script from "./Perizinan.vue?vue&type=script&lang=js"
export * from "./Perizinan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__